import { MasterCropData, MasterUPCData } from '../types';

/** Every crop an item column can show, in display order. */
export function collectUpcCrops(upc: MasterUPCData): MasterCropData[] {
  return [
    ...upc.designs.flatMap((design) => design.crops),
    ...(upc.pendingCrops ?? []),
    ...upc.unassignedCrops,
    ...upc.cartonCrops,
    ...(upc.inactiveCrops ?? []),
  ];
}

/** The selected crops, in the order they appear on screen. */
export function collectSelectedCrops(
  upcData: MasterUPCData[],
  selectedCropIds: ReadonlySet<string>
): MasterCropData[] {
  if (selectedCropIds.size === 0) return [];
  return upcData.flatMap(collectUpcCrops).filter((crop) => selectedCropIds.has(crop.id));
}
